import React from "react";
import { useNavigate } from "react-router-dom";
import {
  TailwindToaster,
  Pagination,
  PropertyThumbnail,
  numberToINR,
  FilterModal,
} from "../../components";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import Multiselect from "multiselect-react-dropdown";

import axios from "../../api/axios";

const Property = () => {
  const state = useSelector((state) => state.UserReducer);
  const navigate = useNavigate();
  const propertyInformationUrl = "/pif";
  const propertyOptionUrl = "/propertyoption";
  const subPropertyOptionUrl = "/subpropertyoption";
  const propertyLocationUrl = "/pifLocation";

  const [pifLocationsSelectedData, setPifLocationsSelectedData] =
    React.useState([]);

  const [propertyLocationsData, setPropertyLocationsData] = React.useState([]);
  const getPropertyLocations = () => {
    try {
      axios
        .get(propertyLocationUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.pifLocations?.length > 0) {
            setPropertyLocationsData(response.data.pifLocations);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [refreshData, setRefreshData] = React.useState(0);
  const [propertyInformationData, setPropertyData] = React.useState([]);
  const [cookies, setCookies] = useCookies(["user"]);
  // const [propertyInformationServerData, setPropertyServerData] = React.useState(
  //   [],
  // );

  const [propertyOptionsData, setPropertyOptionsData] = React.useState([]);
  const [subPropertyOptionsData, setSubPropertyOptionsData] = React.useState([
    { _id: undefined, name: "Select Property" },
  ]);

  const getPropertyOptions = () => {
    try {
      axios
        .get(propertyOptionUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.properties?.length > 0) {
            setPropertyOptionsData(response.data.properties);
            if (cookies.pifviewpropertyOption) {
              updateSubPropertyOptions(cookies.pifviewpropertyOption);
            }
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const updateSubPropertyOptions = (propertyId) => {
    try {
      axios
        .get(subPropertyOptionUrl + "/" + propertyId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          // if (response?.data?.subPropertyOption?.length > 0) {
          setSubPropertyOptionsData(response.data.subPropertyOption);
          // }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [currentPageIndex, setCurrentPageIndex] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(1);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [recordsPerPage, setRecordsPerPage] = React.useState(20);
  const getProperty = () => {
    setRefreshData(0);
    setTotalRecords(0);
    const queryOptions = {
      location,
      propertyOption,
      subPropertyOption,
      approvalStatus: approvalStatus,
      areaUnits,
      minPrice,
      maxPrice,
      facing,
      pifLocations,
    };
    try {
      axios
        .get(propertyInformationUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
          params: {
            queryOptions,
            skip: currentPageIndex * recordsPerPage,
            limit: recordsPerPage,
          },
        })
        .then((response) => {
          // if (response?.data?.property?.length >= 0) {
          setPropertyData(response.data.property);
          // setPropertyServerData(response.data.property);
          if (response.data.propertyInformationCount?.length > 0) {
            setTotalRecords(
              response.data.propertyInformationCount[0].propertyInformationCnt,
            );
            setTotalPages(
              Math.ceil(
                response.data.propertyInformationCount[0]
                  .propertyInformationCnt / recordsPerPage,
              ),
            );
          } else {
            setTotalRecords(0);
            setTotalPages(0);
          }
          setRefreshData(1);
          // }
        })
        .catch((err) => {
          toast.error("Something went wrong");
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [location, setlocation] = React.useState(
    cookies.pifviewlocation ? cookies.pifviewlocation : "",
  );
  const [propertyOption, setpropertyOption] = React.useState(
    cookies.pifviewpropertyOption ? cookies.pifviewpropertyOption : "",
  );
  const [subPropertyOption, setsubPropertyOption] = React.useState(
    cookies.pifviewsubPropertyOption ? cookies.pifviewsubPropertyOption : "",
  );
  const [approvalStatus, setapprovalStatus] = React.useState(
    cookies.pifviewapprovalStatus ? cookies.pifviewapprovalStatus : "",
  );
  const [areaUnits, setareaUnits] = React.useState(
    cookies.pifviewareaUnits ? cookies.pifviewareaUnits : 0,
  );
  const [minPrice, setminPrice] = React.useState(
    cookies.pifviewminPrice ? cookies.pifviewminPrice : 0,
  );
  const [maxPrice, setmaxPrice] = React.useState(
    cookies.pifviewmaxPrice ? cookies.pifviewmaxPrice : 9999999999999,
  );
  const [facing, setfacing] = React.useState(
    cookies.pifviewfacing ? cookies.pifviewfacing : "",
  );
  const [pifLocations, setPIFLocations] = React.useState(
    cookies.pifviewpiflocations ? cookies.pifviewpiflocations.split(",") : [],
  );

  const clearFilters = () => {
    setlocation("");
    setpropertyOption("");
    setsubPropertyOption("");
    setapprovalStatus("");
    setareaUnits(0);
    setminPrice(0);
    setmaxPrice(9999999999999);
    setfacing("");
    setPIFLocations([]);
    setPifLocationsSelectedData([]);
    setCookies("pifviewlocation", "");
    setCookies("pifviewpropertyOption", "");
    setCookies("pifviewsubPropertyOption", "");
    setCookies("pifviewapprovalStatus", "");
    setCookies("pifviewareaUnits", "");
    setCookies("pifviewminPrice", "");
    setCookies("pifviewmaxPrice", "");
    setCookies("pifviewfacing", "");
    setCookies("pifviewpiflocations", "");
  };

  const filterProperties = () => {
    try {
      getProperty();
    } catch (err) {
      console.log(err);
      toast.error("Error while filtering Properties");
    }
  };
  const filterProperties1 = () => {
    try {
      getProperty();
    } catch (err) {
      console.log(err);
      toast.error("Error while filtering Properties");
    }
  };

  const changePageCallback = (targetPageIndex) => {
    setCurrentPageIndex(targetPageIndex);
  };

  const changeDisplayRecordCountCallback = (targetRecordsPerPage) => {
    setRecordsPerPage(targetRecordsPerPage);
    setTotalPages(
      Math.ceil(propertyInformationData?.length / targetRecordsPerPage),
    );
  };

  const [openMobileFilter, setOpenMobileFilter] = React.useState(false);

  const [pageTitle, setPageTitle] = React.useState("Lands & Lands ERP");
  React.useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  React.useEffect(() => {
    const filteredLocation = propertyLocationsData.filter((item) => {
      return pifLocations.includes(item._id.toString());
    });
    setPifLocationsSelectedData(filteredLocation);
  }, [propertyLocationsData, pifLocations]);

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getProperty();
    getPropertyOptions();
    getPropertyLocations();
    setPageTitle("Properties - L&L ERP");
  }, [recordsPerPage, currentPageIndex]);

  return (
    <>
      <TailwindToaster />
      {openMobileFilter && (
        <FilterModal
          moduleName={"Property Filters"}
          closeConfirmation={() => {
            setOpenMobileFilter(!openMobileFilter);
          }}
          updateSubPropertyOptions={updateSubPropertyOptions}
          propertyOptionsData={propertyOptionsData}
          subPropertyOptionsData={subPropertyOptionsData}
          filterProperties={filterProperties1}
          setlocation={setlocation}
          setpropertyOption={setpropertyOption}
          setsubPropertyOption={setsubPropertyOption}
          setapprovalStatus={setapprovalStatus}
          setareaUnits={setareaUnits}
          setminPrice={setminPrice}
          setmaxPrice={setmaxPrice}
          setfacing={setfacing}
          location={location}
          propertyOption={propertyOption}
          subPropertyOption={subPropertyOption}
          approvalStatus={approvalStatus}
          areaUnits={areaUnits}
          minPrice={minPrice}
          maxPrice={maxPrice}
          facing={facing}
          pifLocations={pifLocations}
          propertyLocationsData={propertyLocationsData}
          setPIFLocations={setPIFLocations}
          pifLocationsSelectedData={pifLocationsSelectedData}
          setPifLocationsSelectedData={setPifLocationsSelectedData}
          clearFilters={clearFilters}
        />
      )}
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='lg:flex lg:items-center justify-between'>
              <div className='flex min-w-0 px-5 pt-4 lg:px-0 justify-between'>
                <h2 className='ml-1 text-xl font-semibold leading-7 text-gray-dark sm:text-xl '>
                  Properties
                </h2>
                <button
                  className='sm:hidden inline-flex justify-center px-3 py-1 border-transparent shadow-sm text-sm font-medium rounded-sm bg-gray-400'
                  onClick={(e) => {
                    setOpenMobileFilter(!openMobileFilter);
                  }}>
                  Filters
                </button>
              </div>
            </div>
            <div className='px-4 py-3 sm:px-0'>
              <div className='w-full'>
                <div className='grid grid-cols-12 gap-4'>
                  <div className='sm:col-span-8 col-span-12'>
                    {refreshData !== 0 ? (
                      <div className='pb-4 px-4 grid grid-cols-12 gap-5'>
                        {propertyInformationData?.length !== 0 ? (
                          propertyInformationData.map((item) => (
                            <div
                              key={item._id}
                              onClick={(e) => {
                                navigate("/property/" + item._id);
                              }}
                              className='relative flex-col col-span-6 sm:col-span-3 pt-0 bg-yellow-50 hover:border-yellow-dark duration-300 cursor-default border-gray-50 shadow-sm hover:shadow-xl hover:shadow-yellow-3 opacity-90 hover:opacity-100 '>
                              <div className='justify-center max-h-56 bg-yellow-dark overflow-hidden '>
                                <PropertyThumbnail
                                  key={item.blobName}
                                  thumbnail={item.thumbnail}
                                  isthumbnail={true}
                                />
                              </div>
                              <div className='absolute bottom-0 left-0 px-4 py-2 bg-yellow-light bg-opacity-100 w-full duration-300'>
                                <div className='flex justify-between'>
                                  <span className='text-sm font-semibold text-gray-dark'>
                                    Service #
                                    {item.serviceTicketId.serviceTicketID}
                                  </span>
                                </div>
                                <div className='flex-col'>
                                  <div className='-mt-1'>
                                    <span className='pt-0 text-xs font-semibold text-gray-dark w-full leading-3'>
                                      {numberToINR(item.price)}
                                    </span>
                                  </div>
                                  {/* <div className='mt-2'>
                                    <span className='pt-0 text-xs font-normal text-gray-dark w-full leading-3'>
                                      {item.addressline1}
                                    </span>
                                  </div>
                                  <div className='-mt-2'>
                                    <span className='pt-0 text-xs font-normal text-gray-dark w-full leading-3'>
                                      {item.addressline2}
                                    </span>
                                  </div> */}
                                  <div className='mt-1'>
                                    <p className='pt-0 text-xs font-normal  text-gray-dark w-full leading-normal'>
                                      {item.addressString &&
                                      item.addressString !== ""
                                        ? item.addressString
                                        : "--"}
                                      {item.pincode ? "- " + item.pincode : ""}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className='px-3 py-2 col-span-12'>
                            <h4 className='text-lg font-semibold'>
                              No data to display
                            </h4>
                          </div>
                        )}
                      </div>
                    ) : (
                      <>
                        <div className='sm:flex space-x-3 hidden'>
                          <div className='animate-pulse flex-col items-left justify-center border-b-2 pb-1 border-gray-100 w-full'>
                            <div className='flex-col gap-2'>
                              <div className='w-full bg-gray-100 h-36 rounded-md '></div>
                            </div>
                          </div>
                          <div className='animate-pulse flex-col items-left justify-center border-b-2 pb-1 border-gray-100 w-full'>
                            <div className='flex-col gap-2'>
                              <div className='w-full bg-gray-100 h-36 rounded-md '></div>
                            </div>
                          </div>
                          <div className='animate-pulse flex-col items-left justify-center border-b-2 pb-1 border-gray-100 w-full'>
                            <div className='flex-col gap-2'>
                              <div className='w-full bg-gray-100 h-36 rounded-md '></div>
                            </div>
                          </div>
                          <div className='animate-pulse flex-col items-left justify-center border-b-2 pb-1 border-gray-100 w-full '>
                            <div className='flex-col gap-2'>
                              <div className='w-full bg-gray-100 h-36 rounded-md '></div>
                            </div>
                          </div>
                        </div>
                        <div className='flex space-x-3 sm:hidden'>
                          <div className='animate-pulse flex-col items-left justify-center border-b-2 pb-1 border-gray-100 w-full'>
                            <div className='flex-col gap-2'>
                              <div className='w-full bg-gray-100 h-36 rounded-md '></div>
                            </div>
                          </div>
                          <div className='animate-pulse flex-col items-left justify-center border-b-2 pb-1 border-gray-100 w-full'>
                            <div className='flex-col gap-2'>
                              <div className='w-full bg-gray-100 h-36 rounded-md '></div>
                            </div>
                          </div>
                        </div>
                        <div className='flex space-x-3 sm:hidden'>
                          <div className='animate-pulse flex-col items-left justify-center border-b-2 pb-1 border-gray-100 w-full'>
                            <div className='flex-col gap-2'>
                              <div className='w-full bg-gray-100 h-36 rounded-md '></div>
                            </div>
                          </div>
                          <div className='animate-pulse flex-col items-left justify-center border-b-2 pb-1 border-gray-100 w-full'>
                            <div className='flex-col gap-2'>
                              <div className='w-full bg-gray-100 h-36 rounded-md '></div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    <div className='sm:block hidden'>
                      {totalRecords > 0 && (
                        <Pagination
                          pages={totalPages}
                          currentPage={currentPageIndex}
                          recordsPerPage={recordsPerPage}
                          changePageCallback={changePageCallback}
                          totalRecords={totalRecords}
                          changeDisplayRecordCountCallback={
                            changeDisplayRecordCountCallback
                          }
                        />
                      )}
                    </div>
                  </div>
                  <div className='col-span-3 hidden sm:block '>
                    <div className='flex-col space-y-3 rounded-md bg-gray-100 pt-2 pb-3 px-3'>
                      <label
                        htmlFor='location'
                        className={`block text-md font-medium `}>
                        Filters
                      </label>
                      <div className='w-full mt-1'>
                        <label
                          htmlFor='location'
                          className={`block text-sm font-medium `}>
                          Location
                        </label>
                        <Multiselect
                          className={`mt-0 focus:ring-0 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-xs`}
                          options={propertyLocationsData}
                          selectedValues={pifLocationsSelectedData}
                          onSelect={(selectedList, selectedItem) => {
                            selectedList.map((item) => {
                              delete item["validflag"];
                              delete item["createdAt"];
                              delete item["updatedAt"];
                            });
                            setPifLocationsSelectedData(selectedList);
                            const pifLocationIds = [];
                            selectedList.map((item) => {
                              pifLocationIds.push(item._id);
                            });
                            setPIFLocations(pifLocationIds);
                            setCookies(
                              "pifviewpiflocations",
                              pifLocationIds.join(","),
                              {
                                path: "/",
                                maxAge: 300,
                              },
                            );
                          }}
                          onRemove={(selectedList, removedItem) => {
                            selectedList.map((item) => {
                              delete item["validflag"];
                              delete item["createdAt"];
                              delete item["updatedAt"];
                            });
                            setPifLocationsSelectedData(selectedList);
                            const pifLocationIds = [];
                            selectedList.map((item) => {
                              pifLocationIds.push(item._id);
                            });
                            setPIFLocations(pifLocationIds);
                            setCookies(
                              "pifviewpiflocations",
                              pifLocationIds.join(","),
                              {
                                path: "/",
                                maxAge: 300,
                              },
                            );
                          }}
                          displayValue='name'
                          style={{
                            chips: {
                              background: "#dea302",
                              borderRadius: "2pt",
                            },
                            multiselectContainer: {
                              color: "#000",
                            },
                            inputField: {
                              "font-size": "13px",
                              padding: "3px 5px 3px 7px",
                              width: "100%",
                              border: "none",
                              boxShadow: "none",
                            },
                            searchBox: {
                              border: "solid 0.5px #777",
                              "font-size": "5px",
                              padding: "1px",
                              background: "#fff",
                            },
                          }}
                        />
                      </div>
                      <div className='w-full mt-1'>
                        <label
                          htmlFor='location'
                          className={`block text-sm font-medium `}>
                          Address
                        </label>
                        <input
                          type='text'
                          name='location'
                          id='location'
                          value={location}
                          onChange={(e) => {
                            // filterProperties();
                            setlocation(e.target.value);
                            setCookies("pifviewlocation", e.target.value, {
                              path: "/",
                              maxAge: 300,
                            });
                          }}
                          placeholder='Address'
                          maxLength='20'
                          className='focus:ring-yellow-2 text-sm focus:border-yellow-2 block w-full shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                        />
                      </div>
                      <div className='w-full'>
                        <label
                          htmlFor='propertyOptionId'
                          className={`block text-sm font-medium `}>
                          Property
                        </label>
                        <select
                          id='propertyOptionId'
                          name='propertyOptionId'
                          value={propertyOption}
                          onChange={(e) => {
                            // filterProperties();
                            setpropertyOption(e.target.value);
                            updateSubPropertyOptions(e.target.value);
                            setCookies(
                              "pifviewpropertyOption",
                              e.target.value,
                              {
                                path: "/",
                                maxAge: 300,
                              },
                            );
                          }}
                          defaultValue={propertyOption}
                          className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm`}>
                          <option key='0' value=''>
                            Select
                          </option>
                          {propertyOptionsData?.length > 0 ? (
                            propertyOptionsData.map((item) => (
                              <option key={item?._id} value={item?._id}>
                                {item?.name}
                              </option>
                            ))
                          ) : (
                            <option key='1' value=''>
                              Loading...
                            </option>
                          )}
                        </select>
                      </div>
                      <div className='w-full'>
                        <label
                          htmlFor='subPropertyOptionId'
                          className={`block text-sm font-medium `}>
                          Sub Property
                        </label>
                        <select
                          id='subPropertyOptionId'
                          name='subPropertyOptionId'
                          value={subPropertyOption}
                          onChange={(e) => {
                            setsubPropertyOption(e.target.value);
                            setCookies(
                              "pifviewsubPropertyOption",
                              e.target.value,
                              {
                                path: "/",
                                maxAge: 300,
                              },
                            );
                            // filterProperties();
                          }}
                          className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:ring-yellow-2 focus:border-yellow-2 focus:outline-none sm:text-sm`}>
                          <option key='2' value=''>
                            Select
                          </option>
                          {subPropertyOptionsData?.length > 0 ? (
                            subPropertyOptionsData.map((item) => (
                              <option key={item?._id} value={item?._id}>
                                {item?.name}
                              </option>
                            ))
                          ) : (
                            <option key='3' value=''>
                              Loading...
                            </option>
                          )}
                        </select>
                      </div>
                      <div className='w-full'>
                        <label
                          htmlFor='approvalStatus'
                          className={`block text-sm font-medium `}>
                          Approval Status
                        </label>
                        <select
                          id='approvalStatus'
                          name='approvalStatus'
                          onChange={(e) => {
                            setapprovalStatus(e.target.value);
                            // filterProperties();
                            setCookies(
                              "pifviewapprovalStatus",
                              e.target.value,
                              {
                                path: "/",
                                maxAge: 300,
                              },
                            );
                          }}
                          defaultValue={approvalStatus}
                          className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm`}>
                          <option key='0' value=''>
                            Select
                          </option>
                          <option value='Approved'>Approved</option>
                          <option value='Unapproved'>Unapproved</option>
                        </select>
                      </div>
                      <div className='w-full'>
                        <label
                          htmlFor='areaUnits'
                          className={`block text-sm font-medium `}>
                          Area Units (cents)
                        </label>
                        <input
                          type='text'
                          name='areaUnits'
                          id='areaUnits'
                          onChange={(e) => {
                            setareaUnits(
                              !isNaN(e.target.value)
                                ? e.target.value === ""
                                  ? 0
                                  : Number(e.target.value)
                                : 0,
                            );
                            setCookies("pifviewareaUnits", e.target.value, {
                              path: "/",
                              maxAge: 300,
                            });
                            // filterProperties();
                          }}
                          defaultValue={areaUnits !== 0 ? areaUnits : ""}
                          placeholder='Area Units (in cents)'
                          maxLength='20'
                          className='focus:ring-yellow-2 text-sm focus:border-yellow-2 block w-full shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                        />
                      </div>
                      <div className='w-full'>
                        <label
                          htmlFor='facing'
                          className='block text-sm font-medium text-gray-700'>
                          Facing
                        </label>
                        <select
                          id='facing'
                          name='facing'
                          onChange={(e) => {
                            setfacing(e.target.value);
                            // filterProperties();
                            setCookies("pifviewfacing", e.target.value, {
                              path: "/",
                              maxAge: 300,
                            });
                          }}
                          defaultValue={facing}
                          className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                          <option value=''>Select</option>
                          <option value='North'>North</option>
                          <option value='South'>South</option>
                          <option value='West'>West</option>
                          <option value='East'>East</option>
                          <option value='North-East'>North-East</option>
                          <option value='North-West'>North-West</option>
                          <option value='South-East'>South-East</option>
                          <option value='South-West'>South-West</option>
                          <option value='North and South'>
                            North and South
                          </option>
                          <option value='East and West'>East and West</option>
                          <option value='Others'>Others</option>
                        </select>
                      </div>
                      <div className='w-full'>
                        <label
                          htmlFor='areaUnits'
                          className={`block text-sm font-medium `}>
                          Price
                        </label>
                        <div className='flex gap-x-2'>
                          <input
                            type='text'
                            name='minPrice'
                            id='minPrice'
                            defaultValue={minPrice > 0 ? minPrice : ""}
                            onChange={(e) => {
                              setminPrice(
                                !isNaN(e.target.value)
                                  ? e.target.value === ""
                                    ? 0
                                    : Number(e.target.value)
                                  : 0,
                              );
                              setCookies("pifviewminPrice", e.target.value, {
                                path: "/",
                                maxAge: 300,
                              });
                              // filterProperties();
                            }}
                            placeholder='Minimum'
                            maxLength='13'
                            className='focus:ring-yellow-2 text-sm focus:border-yellow-2 block w-6/12 shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                          />
                          <input
                            type='text'
                            name='maxPrice'
                            id='maxPrice'
                            defaultValue={
                              maxPrice < 9999999999999 ? maxPrice : ""
                            }
                            onChange={(e) => {
                              setmaxPrice(
                                !isNaN(e.target.value)
                                  ? e.target.value === ""
                                    ? 0
                                    : Number(e.target.value)
                                  : 0,
                              );
                              setCookies("pifviewmaxPrice", e.target.value, {
                                path: "/",
                                maxAge: 300,
                              });
                              // filterProperties();
                            }}
                            placeholder='Maximum'
                            maxLength='13'
                            className='focus:ring-yellow-2 text-sm focus:border-yellow-2 block w-6/12 shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                          />
                        </div>
                      </div>
                      <div className='w-full'>
                        {refreshData !== 0 ? (
                          <div className='flex gap-4'>
                            <button
                              className='w-9/12 justify-center px-3 py-2 border-transparent shadow-sm text-sm font-medium rounded-sm bg-yellow-2 hover:bg-yellow-dark duration-300'
                              onClick={(e) => {
                                filterProperties();
                              }}>
                              Filter Properties
                            </button>
                            <button
                              className='inline-flex justify-center py-2 px-4 border-yellow-2 border shadow-sm text-sm font-semibold rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'
                              onClick={(event) => {
                                event.preventDefault();
                                clearFilters();
                              }}>
                              Clear
                            </button>
                          </div>
                        ) : (
                          <button
                            className='animate-bounce cursor-wait mt-2 w-full inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2  duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'
                            disabled={true}>
                            Processing...
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default Property;
